import { useEffect, useState } from 'react';
import CountUp from 'react-countup';
import { BeatLoader } from 'react-spinners';

import { CommunityInfoData } from '../../data/communityInfoTypes';
import { fetchCommunityInfoData } from '../../../../utils/fetchCommunityInfoData';
import './AWMCommunityInfo.css'; // Import the CSS file for styling

const DRIVE_FILE_ID = '10AD2j_gHKq81p-jknRVY9EYFPCyqH5fa';

const AWMCommunityInfo = () => {
  const [communityData, setCommunityData] = useState<CommunityInfoData | null>(
    null
  );
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const loadCommunityData = async () => {
      try {
        setIsLoading(true);
        const data = await fetchCommunityInfoData(DRIVE_FILE_ID);
        setCommunityData(data);
      } catch (error) {
        console.error('Failed to load community info data:', error);
      } finally {
        setIsLoading(false);
      }
    };

    loadCommunityData();
  }, []);

  return (
    <div className="awm-community-info mt-3">
      {isLoading ? (
        <div className="text-center my-5">
          <BeatLoader color="#0d6efd" size={15} margin={2} />
        </div>
      ) : (
        <div className="counter-box">
          <div className="counter-row">
            {communityData?.stats.map((stat, index) => (
              <div
                key={index}
                className="counter-item"
                style={{ animationDelay: `400ms` }}
              >
                <h3 className="number">
                  <CountUp end={stat.value} duration={2} delay={400 / 1000} />
                </h3>
                <div className="heading">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default AWMCommunityInfo;
